import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GeneralService } from 'src/app/services/general.service';

import { BsLocaleService, defineLocale } from 'ngx-bootstrap';
import { esLocale, ptBrLocale } from 'ngx-bootstrap/locale';
import { Subscription } from 'rxjs/internal/Subscription';
import { DataService } from '../../services/data.service';
import { listLocales } from 'ngx-bootstrap/chronos';
import { elementStylingMap } from '@angular/core/src/render3';
import { ThemeService } from 'ng2-charts';

declare let gtag: Function;

defineLocale('es', esLocale);
defineLocale('pt-br', ptBrLocale);

@Component({
  selector: 'app-motor-reserva',
  templateUrl: './motor-reserva.component.html',
  styleUrls: ['./motor-reserva.component.scss']
})
export class MotorReservaComponent implements OnInit {
  unidades: any = [];
  subscription: Subscription;
  idIdioma = '';

  // Datepicker
  minDateDesde = new Date();
  minDateHasta = new Date();
  bsConfig = {
    showWeekNumbers: false,
    dateInputFormat: 'DD • MM • YYYY'
  };

  // Reserva
  unidadReserva = '0';
  fechaDesde = new Date();
  fechaHasta = new Date();
  cantAdultos = 2;
  cantNinos = 0;
  cantAdultosAux = 2;
  cantNinosAux = 0;

  locale = '';
  locales = listLocales();

  toggleSearch = true;
  mobile = false;
  innerWidth: any;

  constructor(
    private translate: TranslateService,
    private localeService: BsLocaleService,
    private dataService: DataService,
    private generalService: GeneralService
  ) { }

  ngOnInit() {
    this.minDateHasta.setDate(this.minDateHasta.getDate() + 1);
    this.fechaHasta.setDate(this.fechaHasta.getDate() + 1);
    this.canales();

    this.subscription = this.dataService.$idioma.subscribe(value => {
      this.idIdioma = value;
      switch (this.idIdioma) {
        case 'en':
          this.localeService.use('en');
          this.locale = 'en';
          break;
        case 'port':
          this.localeService.use('pt-br');
          this.locale = 'pt-br';
          break;
        default:
          this.localeService.use('es');
          this.locale = 'es';
          break;
      }
    });

    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 1200) {
      this.toggleSearch = true;
      this.mobile=false;
    } else {
      this.toggleSearch = false;
      this.mobile=true;
    }
  }

  canales() {
    this.generalService.canales()
      .subscribe(result => {
        if (result['codigo'] === 1) {
          
          result['data'].forEach(element => {
            // tslint:disable-next-line: no-shadowed-variable
            element.canales.forEach((element: any) => {
              this.unidades.push(element);
            });
          });
          //console.log(this.unidades);
        }        
      });
  }

  DateDesde(date) {
    this.localeService.use(this.locale);
    this.fechaDesde = date;
    this.fechaDesde.setHours(0, 0, 0, 0);
    this.fechaHasta.setHours(0, 0, 0, 0);

    if (this.fechaDesde.getTime() >= this.fechaHasta.getTime()) {
      const fechaHastaAux = new Date(date);
      fechaHastaAux.setDate(fechaHastaAux.getDate() + 1);
      this.minDateHasta = fechaHastaAux;
      this.fechaHasta = fechaHastaAux;
    }

    if (this.fechaDesde.getTime() < this.fechaHasta.getTime()) {
      const fechaHastaAux = new Date(date);
      fechaHastaAux.setDate(fechaHastaAux.getDate() + 1);
      this.minDateHasta = fechaHastaAux;
    }
  }

  selectUnidad(id: string) {
    this.unidadReserva = id;
    this.unidades.forEach(element => {
      if(element.codigoCanal  == this.unidadReserva)
      {
        this.cantAdultos = 2;
        this.cantNinos = 0;
        if(this.cantAdultos > element.maxAdultos)
        {
          this.cantAdultos = element.maxAdultos;
        }
        if(this.cantAdultosAux > element.maxAdultos){
          this.cantAdultosAux = element.maxAdultos;
        }
        if(this.cantNinosAux > element.maxNinos){
            this.cantNinosAux = element.maxNinos;
        }
      }
    });
  }

  aplicarHuspedes() {
    this.cantAdultos = this.cantAdultosAux;
    this.cantNinos = this.cantNinosAux;
  }

  huespedesReserva(tipo_huesped, operacion)
  {
    const cn = `${this.unidadReserva}`;
    let adultos = this.cantAdultosAux;
    let ninos = this.cantNinosAux;
    console.log(this.unidades);
    this.unidades.forEach(element => {
      if(element.codigoCanal  == cn)
      {
          if(tipo_huesped == 1) //Adulto
          {
            if(operacion == 0) // Restar
            {
              if((adultos - 1) < 0)
              {
                this.cantAdultosAux = 0;
              }
              else
              {
                this.cantAdultosAux = this.cantAdultosAux - 1;
              }
            }
            else //Sumar
            {
              if((adultos + 1) <= element.maxAdultos)
              {
                this.cantAdultosAux = adultos + 1;
              }
            }
          }
          else  //Niño
          {
            if(operacion == 0) // Restar
            {
              if((ninos - 1) < 0)
              {
                this.cantNinosAux = 0;
              }
              else
              {
                this.cantNinosAux = this.cantNinosAux - 1;
              }
            }
            else //Sumar
            {
              if((ninos + 1) <= element.maxNinos)
              {
                this.cantNinosAux = ninos + 1;
              }
            }
          }
      }
    });    
  }

  buscarReserva() {
    /* FECHA DESDE */
    // tslint:disable-next-line: max-line-length
    const fDesdeDia = this.fechaDesde.getDate() < 10 ? `0${this.fechaDesde.getDate()}` : this.fechaDesde.getDate();
    // tslint:disable-next-line: max-line-length
    const fDesdeMes = (this.fechaDesde.getMonth() + 1) < 10 ? `0${this.fechaDesde.getMonth() + 1}` : this.fechaDesde.getMonth() + 1;
    const fDesdeAnio = this.fechaDesde.getFullYear();

    /* FECHA DESDE */
    // tslint:disable-next-line: max-line-length
    const fHastaDia = this.fechaHasta.getDate() < 10 ? `0${this.fechaHasta.getDate()}` : this.fechaHasta.getDate();
    // tslint:disable-next-line: max-line-length
    const fHastaMes = (this.fechaHasta.getMonth() + 1) < 10 ? `0${this.fechaHasta.getMonth() + 1}` : this.fechaHasta.getMonth() + 1;
    const fHastaAnio = this.fechaHasta.getFullYear();

    const cn = `${this.unidadReserva}`;
   // const fi = `${fDesdeDia}/${fDesdeMes}/${fDesdeAnio}`;
   // const fs = `${fHastaDia}/${fHastaMes}/${fHastaAnio}`;
    const fi = `${fDesdeAnio}-${fDesdeMes}-${fDesdeDia}`;
    const fs = `${fHastaAnio}-${fHastaMes}-${fHastaDia}`;
    const na = `${this.cantAdultos}`;
    const nn = this.cantNinos === 0 ? `${this.cantNinos}` : `${this.cantNinos}`;

    let ci = '';
    switch (this.idIdioma) {
      case 'es':
        ci = 'ES';
        break;
      case 'en':
        ci = 'EN';
        break;
      case 'port':
        ci = 'PO';
        break;
    }

    let money = 'CLP';
    if(cn == 'HCPUN')
    {
        money = 'USD';
    }

    // tslint:disable-next-line: max-line-length
    //           http://ec2-52-67-12-114.sa-east-1.compute.amazonaws.com/MotorReservasWeb/#/home/IdCanal/codigoIdioma/fechaIngreso/fechaSalida/numeroHabitaciones/numeroAdultos/numeroNinos/codigoMoneda/CLP/CodigoMercado
    // tslint:disable-next-line: max-line-length
    //gtag('event', 'Click: Home Motor Reservas', { 'event_category': 'Sección: Motor de Reserva', 'event_label': `${cn}|${fi}|${fs}|${na}|${nn}` , 'value' : '0' });
    //window.open(`http://reservasweb.enjoy.cl/paso_1.aspx?lnk=yes&cn=${cn}&fi=${fi}&fs=${fs}&na=${na}&nn=${nn}&nh=1&ci=E`, '_blank');
    window.open(`https://reservasweb.enjoy.cl/disponibilidad/${cn}/${ci}/${fi}/${fs}/1/${na}/${nn}/${money}/PERSONAS`, '_blank');
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 1200 && this.mobile==true) {
      this.toggleSearch = true;
      this.mobile=false;
    } else if(this.innerWidth < 1200 && this.mobile==false) {
      this.mobile=true;
      //this.toggleSearch = false;
    }
  }

  toogleSearch() {
    this.toggleSearch = !this.toggleSearch;
  }


}
